'use strict';

var helper = require('../helper');

module.exports = {
    pushLoginInteraction (type, socialName, rememberMe, sessionExpired, location, error) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '7',
            'eventname': 'login',
            'type': type || 'login',
            'method': socialName,
            'position': location,
            'step': error ? 'step1_error' : 'step1_success',
            'area': sessionExpired ? 'yes' : 'no',
            'category': rememberMe ? 'yes' : 'no'
        };
        helper.log('Pushing login interaction:', true);
        helper.push(pushObject);
    },

    pushRegisterInteraction (type, location, error) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '8',
            'eventname': 'sign_up_start',
            'step': error ? 'step1_error' : 'step1_success',
            'type': 'site', // TODO: operation_channel
            'position': location
        };
        helper.log('Pushing register interaction - step 1:', true);
        helper.push(pushObject);
    },

    pushRegisterInteractionTelephone (error) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '9',
            'eventname': 'sign_up_step',
            'method': 'registration',
            'action': error ? 'step2_phone_error' : 'step2_phone_success'
        };
        helper.log('Pushing register interaction - step 2:', true);
        helper.push(pushObject);
    },

    pushRegisterInteractionPersonalData (typeReg, error, location, rememberMe) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '10',
            'eventname': 'sign_up_step',
            'step': error ? 'step3_personal_data_error' : 'step3_personal_data_success',
            'type': error ? '' : typeReg,
            'position': location || '',
            'category': rememberMe ? 'yes' : 'no'
        };
        helper.log('Pushing register interaction - step 3:', true);
        helper.push(pushObject);
    },

    pushRegisterConfirmInteraction (location, result, typeOfAccount) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '11',
            'eventname': 'sign_up_step',
            'step': 'step4_thankyou_page_' + result,
            'type': typeOfAccount,
            'position': location || ''
        };
        helper.log('Pushing register interaction - step 4:', true);
        helper.push(pushObject);
    },

    pushRegisterConfirmInteractionDoubleOptin (result) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '12',
            'eventname': 'sign_up',
            'step': 'confirmation_' + result
        };
        helper.log('Pushing register interaction - double optin:', true);
        helper.push(pushObject);
    },

    pushRegisterInteractionLoyaltyRegistration (analyticsMode) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '13',
            'eventname': 'loyalty_card_create',
            'type': analyticsMode,
            'method': 'site' // TODO: check if is on site or in store
        };

        helper.log('Pushing register interaction - loyalty:', true);
        helper.push(pushObject);
    },

    pushUpdateAddress (eventAction) {
        if (!eventAction) {
            return;
        }
        helper.log('Pushing actions related to the shipping adderss: ' + eventAction, true);
        helper.push({
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '56',
            'eventname': 'shipping_address',
            'action': eventAction,
            'step': 'step1'
        });
    },

    pushSubmitUpdateAddress (eventAction) {
        if (!eventAction) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '57',
            'eventname': 'shipping_address',
            'action': eventAction,
            'step': 'step2'
        };
        helper.push(pushObject);
    },

    pushLoginOrRegistrationError (type, step, errorMsg) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '58',
            'eventname': 'frontend_error',
            'type': type,
            'position': step,
            'text': errorMsg
        };
        helper.push(pushObject);
    },

    pushAddCreditCard (location) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '54',
            'eventname': 'credit_card',
            'action': 'add_credit_cart',
            'step': 'step1',
            'position': location
        };
        helper.log('Pushing adding credit card', true);
        helper.push(pushObject);
    },

    pushSaveCreditCard (location) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '55',
            'eventname': 'credit_card',
            'action': 'add_credit_cart',
            'step': 'step2_save',
            'position': location
        };
        helper.log('Pushing saving credit card', true);
        helper.push(pushObject);
    },

    pushUpdateCreditCard (action) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '75',
            'eventname': 'credit_card',
            'action': action,
            'position': 'my_account'
        };
        helper.log('Pushing update credit card', true);
        helper.push(pushObject);
    },

    // 6.61 LOYALTY CARD SUBSCRIPTION - STEP 1
    pushRegisterInteractionLoyalty (flow, error) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '59',
            'eventname': 'loyalty_card_start',
            'step': error ? 'registration_step1_error' : 'registration_step1_success',
            'label': flow
        };
        helper.log('Pushing register interaction - loyalty:', true);
        helper.push(pushObject);
    },

    // 6.62 LOYALTY CARD SUBSCRIPTION - STEP 2
    pushRegisterInteractionLoyaltyStep2 (mode, error) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '60',
            'eventname': 'loyalty_card_step',
            'step': error ? 'registration_step2_error' : 'registration_step2_success',
            'type': 'email'
        };
        helper.log('Pushing register interaction - loyalty:', true);
        helper.push(pushObject);
    },

    // 6.63 LOYALTY CARD SUBSCRIPTION - STEP 3
    pushRegisterInteractionLoyaltyStep3 (mode, error) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '60',
            'eventname': 'loyalty_card_step',
            'step': error ? 'registration_step3_error' : 'registration_step3_success',
            'type': 'phone'
        };
        helper.log('Pushing register interaction - loyalty:', true);
        helper.push(pushObject);
    },

    // 6.64 LOYALTY CARD SUBSCRIPTION - STEP 4
    pushRegisterInteractionLoyaltyStep4 (error, location, rememberMe) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '61',
            'eventname': 'loyalty_card_step',
            'step': error ? 'registration_step4_personal_data_error' : 'registration_step4_personal_data_success',
            'position': location || 'subscription_form',
            'category': rememberMe ? 'yes' : 'no'
        };
        helper.log('Pushing register interaction - loyalty:', true);
        helper.push(pushObject);
    },

    // 6.65 LOYALTY CARD SUBSCRIPTION - THANK YOU PAGE
    pushRegisterInteractionLoyaltyStep5 (location, status) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '62',
            'eventname': 'loyalty_card_thankyou',
            'step': 'registration_thankyou_page_' + status,
            'position': location || 'subscription_form'
        };
        helper.log('Pushing register interaction - loyalty:', true);
        helper.push(pushObject);
    },

    // 6.66 LOYALTY CARD SUBSCRIPTION - CONFIRMATION
    pushRegisterInteractionLoyaltyStep6 (status) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '63',
            'eventname': 'loyalty_card_sign_up',
            'step': 'registration_confirmation_' + status
        };
        helper.log('Pushing register interaction - double optin:', true);
        helper.push(pushObject);
    },

    pushLoyaltyUnsubscribeInteraction () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '68',
            'eventname': 'loyalty_card_unsubscribe',
        };

        helper.log('Pushing loyalty unsubscribe!', true);
        helper.push(pushObject);
    },

    pushRegisterLoyalty (userID, page) {
        if (!userID) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '86',
            'eventname': 'sign_up_for_the_loyalty_program'
        };
        helper.log(`Pushing register loyalty from ${page} page: `, true);
        helper.push(pushObject);
    },

    pushSocialRegistrationInteraction (socialName) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '87',
            'eventname': 'social_sign_up_start',
            'step': 'click_button',
            'type': socialName
        };

        helper.log('Pushing social registration: ', true);
        helper.push(pushObject);
    },

    pushSocialRegistrationStep1Interaction (type, socialName, error) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '88',
            'eventname': 'social_sign_up_step',
            'step': error ? 'registration_step1_error' : 'registration_step1_success',
            'label': type,
            'type': socialName
        };
        helper.log('Pushing social register interaction - step 1:', true);
        helper.push(pushObject);
    },

    pushSocialRegistrationStep2Interaction (type, socialName, error) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '89',
            'eventname': 'social_sign_up_step',
            'step': error ? 'registration_step2_error' : 'registration_step2_success',
            'label': type,
            'type': socialName
        };
        helper.log('Pushing social register interaction - step 2:', true);
        helper.push(pushObject);
    },

    pushSocialRegistrationStep3Interaction (type, socialName, error, rememberMe) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '90',
            'eventname': 'social_registration',
            'step': error ? 'registration_step3_personal_data_error' : 'registration_step3_personal_data_success',
            'text': type,
            'method': socialName,
            'category': rememberMe ? 'yes' : 'no'
        };
        helper.log('Pushing social register interaction - step 3:', true);
        helper.push(pushObject);
    },

    pushSocialRegistrationThankYouInteraction (socialName) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '91',
            'eventCategory': 'social_registration',
            'eventAction': 'registration_thankyou_page_success',
            'dimension75': socialName
        };

        helper.log('Pushing social register interaction - thank you page:', true);
        helper.push(pushObject);
    },

    pushSocialRegistrationConfirmInteraction (socialName) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '92',
            'eventCategory': 'social_registration',
            'eventAction': 'registration_confirmation_success',
            'dimension75': socialName
        };

        helper.log('Pushing social register interaction - confirmation:', true);
        helper.push(pushObject);
    },

    pushPersistentLoginTooltipInteraction () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '99',
            'eventname': 'persistent_login_more_info'
        };

        helper.log('Pushing persistent login tooltip interaction', true);
        helper.push(pushObject);
    },

    pushRatingAndReviewsTabsInteraction (topic) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '105',
            'eventname': 'my_reviews',
            'area': topic
        };

        helper.log('Pushing rating and reviews interaction - account page - tabs', true);
        helper.push(pushObject);
    },

    pushNavigationRelatedToMyAccount (voice) {
        if (!voice) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '113',
            'eventname': 'private_area',
            'menu_items': voice
        };

        helper.log('Pushing navigation related to my account interaction!', true);
        helper.push(pushObject);
    },

    pushNewsletterPreferenceSave (direktMarketingAgreement, profilingAgreement, brandCodes) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '145',
            'eventname': 'privacy_consents',
            'action': 'change_preferences',
            'position': 'account',
            'label': brandCodes,
            'privacy_news': direktMarketingAgreement ? 'on-news_and_promotions' : 'off-news_and_promotions',
            'privacy_custom_news': profilingAgreement ? 'on-custom_news_and_promotions' : 'off-custom_news_and_promotions'
        };

        helper.log('Pushing newsletter and privacy section interaction!', true);
        helper.push(pushObject);
    },

    // 6.150 REMOVE CONFIRMATION - MY ACCOUNT
    pushMyAccountRemoveConfirmation () {
        helper.log('Pushing my account - remove confirmation interaction!', true);
        helper.push({
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '149',
            'eventname': 'account_cancellation_confirmation'
        });
    },

    pushSaveToWallet (walletType) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '146',
            'eventname': 'loyalty_card',
            'label': 'save_on_the_phone',
            'method': walletType
        };

        helper.log('Pushing save to wallet interaction!', true);
        helper.push(pushObject);
    },

    // 7.143 profile enrichment - complete your preferences
    pushProfileEnrichmentLoyaltyOnly () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '151',
            'eventname': 'customer_profile_enrichment_start',
            'step': 'step0-complete_your_preferences'
        };
        helper.log('Pushing customer profile enrichment - survey start');
        helper.push(pushObject);
    },

    // 7.144 profile enrichment - favourite collection
    pushProfileEnrichmentLoyaltyOnlyStep01 (topic, choice) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '152',
            'eventname': 'customer_profile_enrichment',
            'step': 'step1-favourite_collection',
            'category': topic,
            'text': choice,
        };
        helper.log('Pushing customer profile enrichment - step 1');
        helper.push(pushObject);
    },

    // 7.145 profile enrichment - favourite product categories
    pushProfileEnrichmentLoyaltyOnlyStep02 (topic, choice) {
        let pushObject = {
            'event' : 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '153',
            'eventname': 'customer_profile_enrichment',
            'step': 'step2-favourite_product_categories',
            'category': topic,
            'text': choice,
        };
        helper.log('Pushing customer profile enrichment - step 2');
        helper.push(pushObject);
    },

    // 7.146 profile enrichment - kind of fabrics
    pushProfileEnrichmentLoyaltyOnlyStep03 (topic, choice) {
        let pushObject = {
            'event' : 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '154',
            'eventname': 'customer_profile_enrichment',
            'step': 'step3-kind_of_fabrics',
            'category': topic,
            'text': choice,
        };
        helper.log('Pushing customer profile enrichment - step 3');
        helper.push(pushObject);
    },

    // 7.147 profile enrichment - purchasing preferences and hobbies
    pushProfileEnrichmentLoyaltyOnlyStep04 (topic, choice) {
        let pushObject = {
            'event' : 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '155',
            'eventname': 'customer_profile_enrichment',
            'step': 'step4-purchasing_preferences_and_hobbies',
            'category': topic,
            'text': choice,
        };
        helper.log('Pushing customer profile enrichment - step 4');
        helper.push(pushObject);
    },

    // 7.148 profile enrichment - survey finished
    pushProfileEnrichmentLoyaltyOnlyFinished () {
        let pushObject = {
            'event' : 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '156',
            'eventname': 'customer_profile_enrichment_thank_you',
            'step': 'step5-survey_completed'
        };
        helper.log('Pushing customer profile enrichment - survey finished');
        helper.push(pushObject);
    },

    // 7.149 profile enrichment - leave the survey
    pushProfileEnrichmentLoyaltyOnlyLeavingSurvey (topic) {
        let pushObject = {
            'event' : 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '157',
            'eventname': 'customer_profile_enrichment',
            'step': 'leave_the_survey',
            'category': topic
        };
        helper.log('Pushing customer profile enrichment - leaving survey');
        helper.push(pushObject);
    },

    // 7.150 profile enrichment - edit the preferences
    pushProfileEnrichmentLoyaltyOnlyEditingPreferences (topic) {
        let pushObject = {
            'event' : 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '158',
            'eventname': 'customer_profile_enrichment',
            'step': 'edit_the_survey',
            'category': topic
        };
        helper.log('Pushing customer profile enrichment - editing the survey');
        helper.push(pushObject);
    },
};
